module.exports = __webpack_public_path__ + "img/seriously_fun_graphic.64595483.png";